/* eslint-disable */
// VENDORED unchanged from learning_brain_poc/rhs4_lodpick.js (W7b / F3, POC commit 6ad5075e). Side-effect module: sets a window global.
// Chat v4 Details tab: a 'Line of diagnosis' filter above 'One pattern as stored' (neo.js). View only: it narrows the pattern select to
// the possible causes of one line so each can be stepped through; it never touches the chat's focus_lod (the Investigate-this-line override).
// window.Rhs4LodPick = {watch(host, getState)}; neo.js rebuilds its whole view on every pattern change, so the filter is re-attached
// by a MutationObserver. Hidden when lod.enabled is false or when the causes carry no line tags (`lods`).
(function () {
  'use strict';

  const SECTION_TITLE = 'Browse causes by line of diagnosis', LABEL = 'Line of diagnosis', ALL = 'All lines', NONE = 'No stored pattern in this line';
  const LIST_LABEL = line => 'Possible causes in ' + line, ALL_HINT = 'Choose a line to list its possible causes.';
  const OPTION_TEXT = /^(\S+)\s+\u00b7\s+(.*?)(?:\s+\((\d+ (?:conversations?|cases?))\))?$/;      // neo.js option: 'PAT_10 \u00b7 label (4 conversations)'
  const countText = (n, line) => n + ' possible cause' + (n === 1 ? '' : 's') + ' in ' + line;
  const watched = new WeakSet();
  let chosen = '';      // kept across re-renders of the Details tab and of the neo view
  let refocus = '';     // the cause button clicked: neo.js rebuilds the view, so focus goes back to its new button

  function el(tag, cls, text) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = String(text);
    return e;
  }
  const clean = t => (window.Rhs4 && window.Rhs4.cleanLabel ? window.Rhs4.cleanLabel(t) : String(t || ''));

  // pid -> line nids from the causes list (and the chat cards); an untagged cause is in the General line, like rhs4_lod.js counts()
  function linesByPid(state, lod) {
    const out = new Map();
    const add = c => { if (c && c.pid && Array.isArray(c.lods)) out.set(c.pid, c.lods.length ? c.lods : [lod.general]); };
    (state.causes || []).forEach(add);
    ((state.last && state.last.cards) || []).forEach(add);
    return out;
  }

  function attach(host, getState) {
    const sel = host.querySelector('#neoPat');
    if (!sel || sel.dataset.lodpick) return;
    sel.dataset.lodpick = '1';
    const state = getState() || {}, lod = (state.info || {}).lod;
    if (!lod || !lod.enabled || !(lod.definitions || []).length) return;
    const lines = linesByPid(state, lod);
    if (!lines.size) return;      // the server sends no line tags for the causes: nothing to filter by
    if (chosen && !lod.definitions.some(d => d.nid === chosen)) chosen = '';
    const all = [...sel.options].map(o => ({value: o.value, text: o.textContent}));
    const pick = el('select', 'v4-lodpick-sel');
    pick.setAttribute('aria-label', LABEL);
    pick.append(el('option', null, ALL));
    pick.options[0].value = '';
    lod.definitions.forEach(d => {
      const o = el('option', null, clean(d.label) + (typeof d.n_causes === 'number' ? ' (' + d.n_causes + ')' : ''));
      o.value = d.nid; pick.append(o);
    });
    pick.value = chosen;
    const count = el('span', 'meta v4-lodpick-n');
    const label = el('label', 'v4-lodpick');
    label.append(LABEL + ' ', pick, ' ', count);
    const list = el('div', 'v4-lodpick-list');
    list.setAttribute('role', 'group');
    // its own sub-section of the stored view (rhs4_stored.css): heading, then the select and the cause list in one tinted box
    const sec = el('div', 'v4-lodpick-sec'), box = el('div', 'v4-lodpick-box');
    box.append(label, list);
    sec.append(el('h3', null, SECTION_TITLE), box);
    const head = sel.closest('h3');
    (head || sel).before(sec);

    // one button per possible cause of the line: the option text without its 'PAT_x \u00b7' prefix, the id and cases count small
    function causeButton(o, name) {
      const m = OPTION_TEXT.exec(o.text) || [];
      const on = o.value === sel.value, b = el('button', 'v4-lodpick-pc' + (on ? ' on' : ''));
      b.type = 'button'; b.dataset.pid = o.value; b.title = o.text;
      b.setAttribute('aria-pressed', String(on));
      b.append(el('span', null, m[2] || o.text));
      const small = [m[1], m[3]].filter(Boolean).join(' \u00b7 ');
      if (small) b.append(el('small', null, small));
      b.addEventListener('click', () => {
        if (o.value === sel.value) return;
        refocus = o.value; sel.value = o.value;
        sel.dispatchEvent(new Event('change'));      // the same as choosing it in the pattern select
      });
      list.setAttribute('aria-label', LIST_LABEL(name));
      return b;
    }
    function drawList(keep, name) {
      if (!chosen) { list.replaceChildren(el('span', 'meta', ALL_HINT)); return; }
      list.replaceChildren(...keep.map(o => causeButton(o, name)));
      const back = refocus && list.querySelector('[data-pid="' + CSS.escape(refocus) + '"]');
      refocus = '';
      if (back) back.focus();
    }

    function apply() {
      const line = chosen, current = sel.value;
      const keep = line ? all.filter(o => (lines.get(o.value) || []).includes(line)) : all;
      sel.replaceChildren(...(keep.length ? keep : [{value: '', text: NONE}]).map(o => { const x = el('option', null, o.text); x.value = o.value; return x; }));
      sel.disabled = !keep.length;
      const name = line ? clean((lod.definitions.find(d => d.nid === line) || {}).label) : '';
      count.textContent = line ? countText(keep.length, name) : '';
      if (keep.some(o => o.value === current)) { sel.value = current; drawList(keep, name); return; }
      drawList(keep, name);
      if (!keep.length) return;
      sel.value = keep[0].value;
      sel.dispatchEvent(new Event('change'));      // neo.js renders the first pattern of the line, as a pick from the list would
    }
    pick.addEventListener('change', () => { chosen = pick.value; apply(); });
    apply();
  }

  function watch(host, getState) {
    if (!host || watched.has(host) || typeof window.MutationObserver !== 'function') return;
    watched.add(host);
    new window.MutationObserver(() => attach(host, getState)).observe(host, {childList: true, subtree: true});
    attach(host, getState);
  }

  window.Rhs4LodPick = {watch};
})();
